import { render, staticRenderFns } from "./SystemNotify.vue?vue&type=template&id=0d861f52&scoped=true&"
import script from "./SystemNotify.vue?vue&type=script&lang=js&"
export * from "./SystemNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d861f52",
  null
  
)

export default component.exports